<template>
    <div class="o-services-modal-inner">
        <div class="services-modal-inner-header">
            <div class="services-modal-inner-icon-container">
                <img
                    class="services-modal-inner-icon"
                    :src="icon"
                    :alt="name"
                >
            </div>
            <span class="services-modal-inner-headline">
                {{ name }}
            </span>
            <div class="services-modal-inner-floor-info">
                <AFloorInfo 
                    :text="floorInfo"
                />
            </div>
        </div>
        <div class="services-modal-inner-content">
            <div
                class="services-modal-inner-description"
                v-html="description"
            />
            <div
                v-if="distance"
                class="services-modal-inner-guide-block"
            >
                <svg-icon
                    v-if="distanceIcon"
                    original
                    name="icons/guide-path-red"
                    class="services-modal-inner-guide-icon"
                />
                <div class="services-modal-inner-guide-info">
                    <span class="services-modal-inner-guide-text">
                        {{ $t('ui.distance') }}
                    </span>
                    <span class="services-modal-inner-guide-distance">
                        {{ distanceText }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import AFloorInfo from '../../atoms/a-floor-info';

export default {
    name: "OServicesModalInner",
    props: {
        service: {
            type: Object,
            required: true
        },
        distanceIcon: {
            type: String,
            default: ''
        }
    },
    components: {
        AFloorInfo
    },
    computed: {
        ...mapGetters([
            't'
        ]),
        icon() {
            return this.t(this.service, 'icon') || '';
        },
        name() {
            return this.t(this.service, 'name') || '';
        },
        description() {
            return this.t(this.service, 'short_description') || '';
        },
        distance() {
            return this.t(this.service, 'distance') || '';
        },
        distanceText() {
            return `${this.distance} ${this.$t('ui.meter')}` || '';
        },
        floorInfo() {
            return this.t(this.service, 'floor') || '';
        }
    }
}
</script>

<style lang="scss">
@import "theme";
</style>
